export const Namespaces = {
  LOCALE: 'LOCALE',
  MODULES: 'MODULES',
  USER: 'USER', 
  UI: 'UI',
  APP_STATE: 'APP_STATE',
  TASK: 'TASK'
};
  